import React, { useRef } from "react";
import { FaGreaterThanEqual, FaLessThanEqual } from "react-icons/fa";
import NoDataFound from "../../Extra/NoDataFound";
import DownloadExcel from "../../Extra/DownloadExcel";

function getMonthlyTotals(data) {
  const map = {};

  data.forEach((obj) => {
    const key = `${obj.cms_year}-${obj.cms_month}`;

    if (!map[key]) {
      map[key] = {
        cms_year: obj.cms_year,
        cms_month: obj.cms_month,
        wh_lobby: "TOTAL",
        wh_less_than_equals_4hr: 0,
        wh_4_to_6_hr: 0,
        wh_6_to_8_hr: 0,
        wh_8_to_10_hr: 0,
        wh_10_to_12_hr: 0,
        wh_12_to_14_hr: 0,
        wh_more_than_14hr: 0,
        wh_total: 0,
      };
    }

    map[key].wh_less_than_equals_4hr += Number(obj.wh_less_than_equals_4hr);
    map[key].wh_4_to_6_hr += Number(obj.wh_4_to_6_hr);
    map[key].wh_6_to_8_hr += Number(obj.wh_6_to_8_hr);

    map[key].wh_8_to_10_hr +=
      Number(obj.wh_8_to_9_hr) + Number(obj.wh_9_to10_hr);
    map[key].wh_10_to_12_hr +=
      Number(obj.wh_10_to_11_hr) + Number(obj.wh_11_to_12_hr);

    map[key].wh_12_to_14_hr += Number(obj.wh_12_to_14_hr);
    map[key].wh_more_than_14hr += Number(obj.wh_more_than_14hr);

    map[key].wh_total += Number(obj.wh_total);
  });

  return Object.values(map);
}

const CMSWorkingHourPercent = ({ data, otherKey }) => {
  const tableRef = useRef();
  const tempData = data?.filter((o) => o.wh_lobby !== "TOTAL");
  const monthlyTotals = getMonthlyTotals(tempData || []);

  return (
    <div className="newUiBody">
      <div className=" bg-dark text-white ps-2 p-1 d-flex align-items-center justify-content-between ">
        <h5 className="">Crew Working Hour Percentage</h5>
      </div>

      <div className="table-responsive ">
        <div className="" style={{ maxHeight: "400px", overflow: "auto" }}>
          <table
            className="table newUiTable table-striped table-hover"
            ref={tableRef}
            style={{ fontSize: "12px" }}
          >
            <thead className="sticky-top" style={{ zIndex: 1 }}>
              <tr className="table-dark">
                <th>SNo</th>

                {otherKey &&
                  otherKey.map((keyName, k) => {
                    return (
                      <th key={k}>
                        {keyName.replace(/wh_/g, "").replace(/cms_/g, "")}
                      </th>
                    );
                  })}
                <th>
                  <FaLessThanEqual /> 4 hrs
                </th>
                <th>
                  4 <FaGreaterThanEqual /> to <FaLessThanEqual /> 6 hrs
                </th>
                <th>
                  6 <FaGreaterThanEqual /> to <FaLessThanEqual /> 8 hrs
                </th>
                <th>
                  8 <FaGreaterThanEqual /> to <FaLessThanEqual /> 10 hrs
                </th>
                <th>
                  10 <FaGreaterThanEqual /> to <FaLessThanEqual /> 12 hrs
                </th>
                <th>
                  12 <FaGreaterThanEqual /> to <FaLessThanEqual /> 14 hrs
                </th>
                <th>
                  14 <FaGreaterThanEqual /> hrs
                </th>
                <th>Total</th>
              </tr>
            </thead>

            <tbody>
              {/* Normal Rows */}
              {data &&
                data.map(
                  (obj, ind) =>
                    obj.wh_lobby !== "TOTAL" && (
                      <tr key={ind}>
                        <td>{ind + 1}</td>
                        {otherKey &&
                          otherKey.map((keyName, k) => {
                            return <td key={k}>{obj[keyName]}</td>;
                          })}
                        <td>
                          {(
                            (obj.wh_less_than_equals_4hr / obj.wh_total) *
                            100
                          ).toFixed(2)}
                          %
                        </td>{" "}
                        <td>
                          {((obj.wh_4_to_6_hr / obj.wh_total) * 100).toFixed(2)}
                          %
                        </td>{" "}
                        <td>
                          {((obj.wh_6_to_8_hr / obj.wh_total) * 100).toFixed(2)}
                          %
                        </td>{" "}
                        <td>
                          {(
                            ((Number(obj.wh_8_to_9_hr) +
                              Number(obj.wh_9_to10_hr)) /
                              obj.wh_total) *
                            100
                          ).toFixed(2)}
                          %
                        </td>{" "}
                        <td>
                          {(
                            ((Number(obj.wh_10_to_11_hr) +
                              Number(obj.wh_11_to_12_hr)) /
                              obj.wh_total) *
                            100
                          ).toFixed(2)}
                          %
                        </td>{" "}
                        <td>
                          {((obj.wh_12_to_14_hr / obj.wh_total) * 100).toFixed(
                            2
                          )}
                        </td>{" "}
                        <td>
                          {(
                            (obj.wh_more_than_14hr / obj.wh_total) *
                            100
                          ).toFixed(2)}
                          %
                        </td>
                        <td>{obj.wh_total}</td>
                      </tr>
                    )
                )}

              {/* : (
                    monthlyTotals.map(
                      (tot, i) =>
                        tot.cms_month === obj.cms_month && (
                          <tr key={`total-${i}`} className="table-dark">
                            <td></td>
                            <td>{tot.cms_year}</td>
                            <td>{tot.cms_month}</td>
                            <td>TOTAL</td>
                            <td>
                              {(
                                (tot.wh_less_than_equals_4hr / tot.wh_total) *
                                100
                              ).toFixed(2)}
                            </td>{" "}
                            <td>
                              {(
                                (tot.wh_4_to_6_hr / tot.wh_total) *
                                100
                              ).toFixed(2)}
                            </td>{" "}
                            <td>
                              {(
                                (tot.wh_6_to_8_hr / tot.wh_total) *
                                100
                              ).toFixed(2)}
                            </td>{" "}
                            <td>
                              {(
                                (tot.wh_8_to_10_hr / tot.wh_total) *
                                100
                              ).toFixed(2)}
                            </td>{" "}
                            <td>
                              {(
                                (tot.wh_10_to_12_hr / tot.wh_total) *
                                100
                              ).toFixed(2)}
                            </td>{" "}
                            <td>
                              {(
                                (tot.wh_12_to_14_hr / tot.wh_total) *
                                100
                              ).toFixed(2)}
                            </td>
                            <td>
                              {(
                                (tot.wh_more_than_14hr / tot.wh_total) *
                                100
                              ).toFixed(2)}
                            </td>
                            <td>{tot.wh_total}</td>
                          </tr>
                        )
                    )
                  ) */}

              {/* Month-wise TOTAL rows */}
              {}
            </tbody>
          </table>
        </div>
      </div>

      {data?.length === 0 ? (
        <NoDataFound />
      ) : (
        <DownloadExcel tableRef={tableRef} fileName={`Crew Working Hours`} />
      )}
    </div>
  );
};

export default CMSWorkingHourPercent;
